import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { take } from 'rxjs/operators';
import { AmbitosPaisesService } from 'src/app/core/providers/services/ambitos-paises/ambitos-paises.service';
import { ValidationDiscountService } from 'src/app/core/providers/services/validation-discount/validation-discount.service';
import { Numbers } from 'src/app/utils/constants';

@Injectable()
export class UtilsService {
  /**
   * @description constructor
   * @params tr
   */
  constructor(private tr: TranslateService) {
    this.tr = tr;
  }
  /**
   * @description recuperar traducción
   * @params key
   */
  getTranslate(key: string): string {
    let translatedlabel = '';
    this.tr.get(key)
      .pipe(take(1))
      .subscribe(e => { translatedlabel = e; });
    return translatedlabel;
  }
  /**
   * @description De string a numero
   * @params str
   */
  stringToNumber(str: string): number {
    let result = 0;
    if (typeof str === 'number') {
      result = str;
    }
    const justNumbers = new RegExp(/\d/g);
    // const next = str.match(justNumbers).join('');
    const next: string = (justNumbers.test(str)) ? str.match(justNumbers).join('') : '0';
    // tslint:disable-next-line: radix
    result = parseInt(next, Numbers.number10);
    return result;
  }

  /**
   *
   * @description cambia una fecha en formato: dd/mm/yyyy -> yyyy/mm/dd
   * @example
   * changeDateOrderToService('22/3/2021')
   * @returns '2021-3-22'
   */
  changeDateOrderToService(str: string): string {
    let result: string;
    if (str) {
      const stringSplitted: string[] = str.split('/');
      const reposition: string[] = [stringSplitted[Numbers.number2], stringSplitted[Numbers.number1], stringSplitted[Numbers.number0]];
      result = reposition.join('-');
    }
    return result;
  }

  /**
   *
   * @description cambia una fecha en formato a 1 año: dd/mm/yyyy -> yyyy/mm/dd
   * @example
   * changeDateOrderToServiceAnual('22/3/2021')
   * @returns '2022-3-21'
   */
  changeDateOrderToServiceAnual(str: string): string {
    if (str) {
      const stringSplitted: string[] = str.split('/');
      const maxDate = new Date(stringSplitted[Numbers.number2] + '-' + stringSplitted[
        Numbers.number1] + '-' + stringSplitted[Numbers.number0]);
      maxDate.setDate(maxDate.getDate() + Numbers.number364);
      const result: string = this.parseDateToShort(maxDate);

      return result;
    }
  }

  /**
   * @description recibe una fecha en formato '2021/3/22' -> '2021/03/22'
   * @param str es una fecha en formato '2021/3/22'
   * @param noAdd0 Si es true no agregara el 0 delante del mes '2021/3/22' -> '2021/3/22'
   */
  dateDecrementOneMonth(str: string, noAdd0?: boolean): string {
    let result: string;
    if (str) {
      const stringSplitted: string[] = str.split('/');
      const monthRaw: number = +stringSplitted[1];
      const month = monthRaw - 1;
      let monthInString: string;
      if (!noAdd0 && month < Numbers.number10) {
        monthInString = `0${month}`;
      } else {
        monthInString = `${month}`;
      }

      const reposition: string[] = [stringSplitted[Numbers.number0], monthInString, stringSplitted[Numbers.number2]];
      result = reposition.join('/');
    }
    return result;
  }

  /**
   * @description Convierte una fecha larga en un formato corto ej: 'yyyy-mm-dd';
   * @param date fecha del campo
   */
  parseDateToShort(fecha: Date): string {
    let dateShort: string = moment(fecha).format('YYYY-MM-DD');
    if (!fecha) {
      dateShort = '';
    }
    return dateShort;
  }

  /**
   * @description Convierte una fecha larga n un formato corto ej: 'dd-mm-yyyy';
   * @param dat fecha del campo
   */
  parseDateToShortDay(fecha: Date): string {
    let dateShort: string = moment(fecha).format('DD-MM-YYYY');
    if (!fecha) {
      dateShort = '';
    }
    return dateShort;
  }

  /**
   * @description Convierte una cadena con la primera letra en mayuscula a minuscula
   * ej: 'HolaMundo' -> 'holaMundo'
   */
  makeCamelCase(str: string): string {
    let result: string;
    if (str) {
      const normal: string[] = str.split('');
      normal[0] = normal[0].toLowerCase();
      result = normal.join('');
    }
    return result;
  }

  /**
   * @description Retorna el dia de hoy en formato: 'yyyy-mm-dd'
   */
  getDateToday(): string {
    const dateToday = new Date();
    const monthA = dateToday.getMonth() + 1;
    const dayA: number = dateToday.getDate();
    let monthInString = `${monthA}`;
    if (monthA < Numbers.number10) { monthInString = `0${monthA}`; }
    let dayInString = `${dayA}`;
    if (dayA < Numbers.number10) { dayInString = `0${dayA}`; }
    const dateTodayParsed = `${dateToday.getFullYear()}-` + monthInString + `-` + dayInString;
    return dateTodayParsed;
  }
  /**
   * @description validar y volver
   * @params str
   */
  validateAndReturn(str: string): string {
    const emailExpression = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi;
    let retorno = '';
    if (emailExpression.test(str)) { retorno = str; }
    return retorno;
  }

  /**
   * getEnvironmentCountrySubscribe
   * @param apSrv apSrv
   * @param name name
   * @param callback callback
   */
  getEnvironmentCountrySubscribe(apSrv: AmbitosPaisesService, name: string, callback: (countryEnvironmentCode: any) => void): void {
    apSrv.getEnvironmentCountry(name)
      .pipe(take(1))
      .subscribe(callback);
  }

  /**
   * getCheckValidationCodeSubscribe
   * @param vdSrv vdSrv
   * @param code code
   * @param callback callback
   */
  getCheckValidationCodeSubscribe(vdSrv: ValidationDiscountService, code: string, callback: (codeStatus: any) => void): void {
    vdSrv.getCheckValidationCode(code)
    .pipe(take(1))
    .subscribe(callback);
  }
}
